function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "transaction",
  transform: "translate(100.000000, 101.000000) scale(-1, 1) translate(-100.000000, -101.000000) "
}, /*#__PURE__*/React.createElement("path", {
  d: "M100,101.042957 C100,34.3762906 100,1.0429573 100,1.0429573 C45,1.0429573 0,45.8144823 0,101.042957 C0,101.042957 33.3333333,101.042957 100,101.042957 Z",
  id: "Oval",
  fill: "#33CCFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100,201.042957 C100,134.376291 100,101.042957 100,101.042957 C44,101.042957 0,145.814482 0,201.042957 C0,201.042957 33.3333333,201.042957 100,201.042957 Z",
  id: "Oval",
  fill: "#50E3C2",
  transform: "translate(50.000000, 151.042957) scale(1, -1) translate(-50.000000, -151.042957) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.042957,101 C200.042957,34.3333333 200.042957,1 200.042957,1 C150.042957,1 97.5429573,41 100.042957,101 C100.042957,101 133.376291,101 200.042957,101 Z",
  id: "Oval-Copy",
  fill: "#EE5366",
  transform: "translate(150.000000, 51.000000) rotate(90.000000) translate(-150.000000, -51.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M200,201.042957 C200,134.376291 200,101.042957 200,101.042957 C150,101.042957 100,141.542957 100,201.042957 C100,201.042957 133.333333,201.042957 200,201.042957 Z",
  id: "Oval-Copy-2",
  fill: "#F5A623",
  transform: "translate(150.000000, 151.042957) scale(1, -1) rotate(90.000000) translate(-150.000000, -151.042957) "
})));

function SvgTimerchartFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "202px",
    viewBox: "0 0 200 202",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transaction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerchartFull);
export default __webpack_public_path__ + "static/media/timerchart-full.3da7fe90.svg";
export { ForwardRef as ReactComponent };